// import { useDispatch } from 'react-redux';
// import { showMessage } from 'app/store/fuse/messageSlice';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormDateTimeField from 'modules/ui/editform/fields/EditFormDateTimeField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
// import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import { useParams, withRouter } from 'react-router';
import MeasurementService from 'app/admin/measurement/service/MeasurementService';
import OutlierDetectorService from 'app/admin/outlierDetector/service/OutlierDetectorService';
import PiMeasurementReaderService from 'app/admin/piMeasurementReader/service/PiMeasurementReaderService';
import LabMeasurementReaderService from 'app/admin/labMeasurementReader/service/LabMeasurementReaderService';
import OptimizationCaseService from 'app/admin/optimizationCase/service/OptimizationCaseService';
import UnitOptimizerService from 'app/admin/unitOptimizer/service/UnitOptimizerService';
import OptimizerService from 'app/admin/optimizer/service/OptimizerService';
import DatasetService from 'app/admin/dataset/service/DatasetService';
// import AspectService from 'app/admin/aspect/service/AspectService';
// import ModelValidationLogService from 'app/admin/modelValidationLog/service/ModelValidationLogService';
import ModelValidationService from 'app/admin/modelValidation/service/ModelValidationService';
import OptimizationPipelineService from 'app/admin/optimizationPipeline/service/OptimizationPipelineService';
import OptimizationPipelineLogService from 'app/admin/optimizationPipelineLog/service/OptimizationPipelineLogService';
import TaskManagerType from '../dto/TaskManagerType';
// import TaskManagerService from '../service/TaskManagerService';
import TaskManagerEditService from '../service/TaskManagerEditService';
import PiMeasurementReaderTaskService from '../service/PiMeasurementReaderTaskService';
import PiMeasurementReaderTaskEditService from '../service/PiMeasurementReaderTaskEditService';
import LabMeasurementReaderTaskService from '../service/LabMeasurementReaderTaskService';
import LabMeasurementReaderTaskEditService from '../service/LabMeasurementReaderTaskEditService';
import MeasurementMergeTaskService from '../service/MeasurementMergeTaskService';
import MeasurementMergeTaskEditService from '../service/MeasurementMergeTaskEditService';
import DataCleanTaskService from '../service/DataCleanTaskService';
import DataCleanTaskEditService from '../service/DataCleanTaskEditService';
import OutlierDetectorTrainerTaskEditService from '../service/OutlierDetectorTrainerTaskEditService';
import OutlierDetectionTaskService from '../service/OutlierDetectionTaskService';
import OutlierDetectionTaskEditService from '../service/OutlierDetectionTaskEditService';
import ModelValidationTaskService from '../service/ModelValidationTaskService';
import ModelValidationTaskEditService from '../service/ModelValidationTaskEditService';
import DataSplitTaskEditService from '../service/DataSplitTaskEditService';
import OptimizationCaseTaskEditService from '../service/OptimizationCaseTaskEditService';
import StorageTaskManagerService from '../service/StorageTaskManagerService';
import OptimizersComparisonTaskEditService from '../service/OptimizersComparisonTaskEditService';
// import OptimizeUnitTaskEditService from '../service/OptimizeUnitTaskEditService';
import UnitOptimizerTaskService from '../service/UnitOptimizerTaskService';
import UnitOptimizerTaskEditService from '../service/UnitOptimizerTaskEditService';
import OptimizationPipelineTaskEditService from '../service/OptimizationPipelineTaskEditService';
import { useTaskManager } from '../component/TaskManagerProvider';
import EdtDynamicCheckService from 'app/admin/edtDynamicCheck/service/EdtDynamicCheckService';
import EdtDynamicCheckTaskEditService from '../service/EdtDynamicCheckTaskEditService';
import PiWriterService from 'app/admin/piWriter/service/PiWriterService';
import PiWriterTaskEditService from '../service/PiWriterTaskEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';
import OpcDaWriterService from 'app/admin/opcDaWriter/service/OpcDaWriterService';
import OpcDaWriterTaskEditService from 'app/admin/taskManager/service/OpcDaWriterTaskEditService';

const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
const blockTitleClassName = 'py-8';

const taskManagerService = type => {
	if (type === 'PiMeasurementReader') return PiMeasurementReaderTaskEditService;
	if (type === 'LabMeasurementReader') return LabMeasurementReaderTaskEditService;
	if (type === 'MeasurementMerge') return MeasurementMergeTaskEditService;
	if (type === 'DataClean') return DataCleanTaskEditService;
	if (type === 'OutlierDetectorTrainer') return OutlierDetectorTrainerTaskEditService;
	if (type === 'OutlierDetection') return OutlierDetectionTaskEditService;
	if (type === 'ModelValidation') return ModelValidationTaskEditService;
	if (type === 'DataSplit') return DataSplitTaskEditService;
	if (type === 'Optimize') return OptimizationCaseTaskEditService;
	if (type === 'OptimizersComparison') return OptimizersComparisonTaskEditService;
	if (type === 'UnitOptimizer') return UnitOptimizerTaskEditService;
	// if (type === 'OptimizeUnit') return UnitOptimizerTaskEditService;
	if (type === 'OptimizationPipeline') return OptimizationPipelineTaskEditService;
	if (type === 'EdtDynamicCheck') return EdtDynamicCheckTaskEditService;
	if (type === 'PiWriter') return PiWriterTaskEditService;
	if (type === 'OpcDaWriter') return OpcDaWriterTaskEditService;

	return TaskManagerEditService;
};

const config = data => {
	const storageTaskManagerService = new StorageTaskManagerService();

	return {
		key: 'taskManagerEditForm',
		topic: 'taskManager',
		service: taskManagerService(data.type),
		defaultValue: () => taskManagerService(data.type).createByType(data.type),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'type',
					component: EditFormSelectField,
					required: true,
					readOnly: true,
					type: 'enum',
					items: Object.keys(TaskManagerType).map(key => {
						return { label: TaskManagerType[key], value: key };
					})
				},
				// ...((data.type === 'DataClean' || data.type === 'MeasurementMerge' || data.type === 'OutlierDetection' || data.type === 'ModelValidation' || data.type === 'Optimize' || data.type === 'OptimizersComparison' || data.type === 'PiMeasurementReader' || data.type === 'LabMeasurementReader' /*|| data.type === 'PiWriter'*/) ? [
				{
					key: 'backfill',
					component: EditFormTextField,
					type: 'number',
					// integerOnly: true,
					step: 1,
				},
				// ] : []),
				...((data.type === 'PiMeasurementReader' && data.id === 'new') ? [
					{
						key: 'scheduleGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepSchedule',
								text: 'Schedule',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'scheduleInnerGroup',
								component: EditFormGroupFields,
								className: 'flex flex-col sm:flex-row',
								fields: [
									{
										key: 'schedule.minute',
										component: EditFormTextField,
										className: 'sm:mr-6',
										required: true,
										mask: { mask: /^\*$|^[0-9]{0,2}$/ }
									},
									{
										key: 'schedule.hour',
										component: EditFormTextField,
										className: 'sm:mr-6',
										required: true,
										mask: { mask: /^\*$|^[0-9]{0,2}$/ }
									},
									{
										key: 'schedule.day',
										component: EditFormTextField,
										className: 'sm:mr-6',
										required: true,
										mask: { mask: /^\*$|^[0-9]{0,2}$/ }
									},
									{
										key: 'schedule.month',
										component: EditFormTextField,
										className: 'sm:mr-6',
										required: true,
										mask: { mask: /^\*$|^[0-9]{0,2}$/ }
									}
								]
							}
						]
					}
				] : []),
				...((data.type === 'PiMeasurementReader') ? [
					{
						key: 'measurement',
						component: EditFormSelectField,
						required: true,
						items: () => MeasurementService.getListSelection()
					},
					{
						key: 'reader',
						component: EditFormSelectField,
						required: true,
						items: () => PiMeasurementReaderService.getListSelection()
					},
					{
						key: 'summaryDuration',
						component: EditFormTextField,
						required: true,
						type: 'number',
						integerOnly: true
					},
					{
						key: 'summaryDurationUnit',
						component: EditFormSelectField,
						required: false,
						type: 'enum',
						items: [
							{ label: 'Hour', value: 'HOUR' },
							{ label: 'Day', value: 'DAY' }
						]
					},
					{
						key: 'summaryType',
						component: EditFormSelectField,
						required: false,
						type: 'enum',
						items: [
							{ label: 'Total', value: 'TOTAL' },
							{ label: 'Average', value: 'AVERAGE' },
							{ label: 'Minimum', value: 'MINIMUM' },
							{ label: 'Maximum', value: 'MAXIMUM' }
						]
					}
				] : []),
				...((data.type === 'LabMeasurementReader') ? [
					{
						key: 'measurement',
						component: EditFormSelectField,
						required: true,
						items: () => MeasurementService.getListSelection()
					},
					{
						key: 'reader',
						component: EditFormSelectField,
						required: true,
						items: () => LabMeasurementReaderService.getListSelection()
					},
					// {
					// 	key: 'unitOptimizer',
					// 	component: EditFormSelectField,
					// 	required: false,
					// 	items: () => UnitOptimizerService.getListSelection()
					// },
					{
						key: 'labMeasurementReaderGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'duplicateLastValueIfMissing',
								component: EditFormCheckboxField,
								text: 'Duplicate last value if missing',
								defaultValue: false
							},
							{
								key: 'deleteTimeFromTs',
								component: EditFormCheckboxField,
								text: 'Delete time from timestamp'
							},
							{
								key: 'deleteFromOutput',
								component: EditFormCheckboxField,
								text: 'Delete from output'
							},
							{
								key: 'sortComponents',
								component: EditFormCheckboxField,
								text: 'Sort components'
							},
							{
								key: 'imputeNansWithZero',
								component: EditFormCheckboxField,
								text: 'Impute Nans with zero'
							},
						]
					}
				] : []),
				...((data.type === 'MeasurementMerge') ? [
					{
						key: 'mergeGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sep',
								text: 'Merge Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'inputMeasurements',
								component: EditFormSelectField,
								required: true,
								multiple: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'outputMeasurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'optimizationPipelineLog',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineLogService.getListSelection()
							},
							{
								key: 'deleteTimeFromTs',
								component: EditFormCheckboxField
							},
							{
								key: 'skipRowsWithNullValues',
								component: EditFormCheckboxField
							},
							{
								key: 'addOrUpdate',
								component: EditFormCheckboxField
							},
							{
								key: 'deleteFromOutput',
								component: EditFormCheckboxField
							}
						]
					}
				] : []),
				...((data.type === 'DataClean') ? [
					{
						key: 'dataCleanGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sep',
								text: 'Data Clean Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'inputMeasurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'outputMeasurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'optimizationPipelineLog',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineLogService.getListSelection()
							},
							{
								key: 'outlierRemoval',
								component: EditFormCheckboxField
							},
							{
								key: 'skewnessCorrection',
								component: EditFormCheckboxField
							},
						]
					}
				] : []),
				...((data.type === 'OutlierDetectorTrainer') ? [
					{
						key: 'trainOutlierDetectorGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sep',
								text: 'Train Outlier Detector Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'measurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'outlierDetector',
								component: EditFormSelectField,
								required: true,
								items: () => OutlierDetectorService.getListSelection()
							},
							{
								key: 'timeWindowInDays',
								component: EditFormTextField,
								type: 'number',
								integerOnly: true
							}
						]
					}
				] : []),
				...((data.type === 'OutlierDetection') ? [
					{
						key: 'outlierDetectionGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sep',
								text: 'Outlier Detection Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'measurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'outlierDetectors',
								component: EditFormSelectField,
								required: true,
								multiple: true,
								items: () => OutlierDetectorService.getListSelection()
							},
						]
					}
				] : []),
				...((data.type === 'ModelValidation') ? [
					{
						key: 'modelValidationGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepModelValidation',
								text: 'Model Validation Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'modelValidation',
								component: EditFormSelectField,
								required: true,
								items: () => ModelValidationService.getListSelection()
							},
							{
								key: 'optimizationPipelineLog',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineLogService.getListSelection()
							},
						]
					}
				] : []),
				...((data.type === 'DataSplit') ? [
					{
						key: 'dataSplitGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepDataSplit',
								text: 'Data Split Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'measurement',
								component: EditFormSelectField,
								required: true,
								items: () => MeasurementService.getListSelection()
							},
							{
								key: 'dataset',
								component: EditFormSelectField,
								required: true,
								items: () => DatasetService.getListSelection()
							},
							{
								key: 'keyFieldsGroup',
								component: EditFormGroupFields,
								className: blockClassName,
								fields: [
									{
										key: 'sepKeyFields',
										text: 'Key Fields',
										component: EditFormSeparatorField,
										className: blockTitleClassName + ' pb-16',
										isControlledInput: false
									},
									{
										key: 'keyFields',
										component: EditFormGridComponent,
										defaultValue: {
											measurementFieldName: null
										},
										fields: [
											{
												key: 'measurementFieldName',
												text: 'Field name',
												component: EditFormTextField,
												required: true,
											}
										]
									}
								]
							},
							{
								key: 'valueFieldsGroup',
								component: EditFormGroupFields,
								className: blockClassName,
								fields: [
									{
										key: 'sepValueFields',
										text: 'Value Fields',
										component: EditFormSeparatorField,
										className: blockTitleClassName + ' pb-16',
										isControlledInput: false
									},
									{
										key: 'valueFields',
										component: EditFormGridComponent,
										defaultValue: {
											measurementFieldName: null
										},
										fields: [
											{
												key: 'measurementFieldName',
												text: 'Field name',
												component: EditFormTextField,
												required: true,
											}
										]
									}
								]
							}
						]
					}
				] : []),
				...((data.type === 'Optimize') ? [
					{
						key: 'optimizationCaseGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepOptimizationCase',
								text: 'Optimization Case Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'optimizationCase',
								component: EditFormSelectField,
								required: true,
								items: () => OptimizationCaseService.getListSelection()
							}
						]
					}
				] : []),
				...((data.type !== 'Optimize') ? [
					{
						key: 'dateTimeGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'setDateTime',
								text: 'Date Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'startDateTime',
								component: EditFormDateTimeField
							},
							{
								key: 'endDateTime',
								component: EditFormDateTimeField
							},
							{
								key: 'skipToday',
								component: EditFormCheckboxField,
								text: 'Skip Today',
								defaultValue: false
							}
						]
					}

				] : []),
				...((data.type === 'OptimizersComparison') ? [
					{
						key: 'optimizersComparisonGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepOptimizersComparison',
								text: 'Optimizers Comparison Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'optimizationCase',
								component: EditFormSelectField,
								required: true,
								items: () => OptimizationCaseService.getListSelection()
							},
							{
								key: 'optimizers',
								component: EditFormSelectField,
								required: true,
								multiple: true,
								items: () => OptimizerService.getListSelection()
							}
						]
					}
				] : []),
				...((data.type === 'UnitOptimizer') ? [
					{
						key: 'unitOptimizerGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepUnitOptimizer',
								text: 'Unit Optimizer Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'unitOptimizer',
								component: EditFormSelectField,
								required: false,
								items: () => UnitOptimizerService.getListSelection()
							},
							{
								key: 'optimizationPipelineLog',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineLogService.getListSelection()
							}
						]
					}
				] : []),
				...((data.type === 'OptimizationPipeline') ? [
					{
						key: 'optimizationPipelineGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepOptimizationPipeline',
								text: 'Optimization Pipeline Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'piMeasurementReaderTasks',
								component: EditFormSelectField,
								multiple: true,
								items: () => PiMeasurementReaderTaskService.getListSelection()
							},
							{
								key: 'labMeasurementReaderTasks',
								component: EditFormSelectField,
								multiple: true,
								items: () => LabMeasurementReaderTaskService.getListSelection()
							},
							{
								key: 'measurementMergeTask',
								component: EditFormSelectField,
								items: () => MeasurementMergeTaskService.getListSelection()
							},
							{
								key: 'outlierDetectionTask',
								component: EditFormSelectField,
								items: () => OutlierDetectionTaskService.getListSelection()
							},
							{
								key: 'dataCleanTask',
								component: EditFormSelectField,
								items: () => DataCleanTaskService.getListSelection()
							},
							{
								key: 'modelValidationTask',
								component: EditFormSelectField,
								items: () => ModelValidationTaskService.getListSelection()
							},
							{
								key: 'unitOptimizerTask',
								component: EditFormSelectField,
								items: () => UnitOptimizerTaskService.getListSelection()
							},
						]
					}
				] : []),
				...((data.type === 'EdtDynamicCheck') ? [
					{
						key: 'edtDynamicCheckGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepEdtDynamicCheck',
								text: 'Edt Dynamic Check Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'edtDynamicCheck',
								component: EditFormSelectField,
								required: false,
								items: () => EdtDynamicCheckService.getListSelection()
							},
							{
								key: 'optimizationPipelineLog',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineLogService.getListSelection()
							}
						]
					}
				] : []),
				...((data.type === 'PiWriter') ? [
					{
						key: 'piWriterGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepPiWriter',
								text: 'Pi Writer Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'piWriter',
								component: EditFormSelectField,
								required: false,
								items: () => PiWriterService.getListSelection()
							},
							{
								key: 'optimizationPipeline',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineService.getListSelection()
							}
						]
					}
				] : []),
					...((data.type === 'OpcDaWriter') ? [
					{
						key: 'opcDaWriterGroup',
						component: EditFormGroupFields,
						className: blockClassName,
						fields: [
							{
								key: 'sepOpcDaWriter',
								text: 'OPC DA Writer Options',
								component: EditFormSeparatorField,
								className: blockTitleClassName,
								isControlledInput: false
							},
							{
								key: 'opcDaWriter',
								component: EditFormSelectField,
								required: false,
								items: () => OpcDaWriterService.getListSelection()
							},
							{
								key: 'optimizationPipeline',
								component: EditFormSelectField,
								required: false,
								items: () => OptimizationPipelineService.getListSelection()
							}
						]
					}
				] : []),
			];
			return fields;
		}
	};
};

function TaskManagerEditForm() {
	const { id, type } = useParams();
	const taskManagerProvider = useTaskManager();
	const myConfig = config({ id, type, taskManagerProvider });

	return (
		<EditFormPage config={myConfig} onWatch={(d) => taskManagerProvider.setAspectId(d.aspect)} />
	);
}

export default withRouter(TaskManagerEditForm);